import {Dispatch, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {QuartermasterAction} from '../state';

/** Applies deep-link filters once per URL, after the accessible locations and transits load. */
export function useQuartermasterQuery(rigs: any[], transits: any[], rigID: string, carrierID: string,
                                     dispatch: Dispatch<QuartermasterAction>) {
    const {search} = useLocation();
    const applied = useRef({search: null as string, location: false, transit: false});

    useEffect(() => {
        const params = new URLSearchParams(search);
        if (applied.current.search !== search) {
            applied.current = {search, location: false, transit: false};
            const name = params.get('search') || '';
            dispatch({type: 'set-pob-search-input', value: name});
            dispatch({type: 'apply-pob-search', value: name});
        }

        const location = params.get('location');
        if (!applied.current.location) {
            if (location) {
                const rig = rigs.find(item => item.locationID?._id === location || item._id === location);
                if (!rig) return;
                applied.current.location = true;
                if (rig._id !== rigID) {
                    dispatch({type: 'select-location', id: rig._id, name: rig.name || rig.locationID?.name});
                    return;
                }
            } else {
                applied.current.location = true;
            }
        }

        const transitID = params.get('transit');
        if (!applied.current.transit && transitID) {
            const transit = transits.find(item => item.carrierID === transitID);
            if (!transit) return;
            applied.current.transit = true;
            if (transitID !== carrierID) {
                dispatch({type: 'select-transit', id: transitID, name: transit.carrierName});
            }
        }
    }, [search, rigs, transits, rigID, carrierID, dispatch]);
}
